// tuning/render.ts (M0-T06, §7.2)
import type { TuningBank } from '../schema/tuning';

export default { maxDpr: 2, targetFps: 60, minFps: 30, maxDrawCalls: 150, dynResMin: 0.6, dynResStep: 0.05, shadowMapHigh: 2048,
  dynResDownRatio: 1.25, dynResUpRatio: 1.05, dynResUpWindows: 3,   // dynRes*Ratio/UpWindows: rev 7 item 33
  // Trees and rocks (2026-10-16, world/instancer.ts): instanced scenery is culled per instance to what the camera sees, and a tree
  // at least farModelFrom (world units) from the camera draws its far model. The town camera sees nothing that far (its farthest
  // tree is about 28 away zoomed right out), so in town every tree you see is near; the title's view from high up is all far.
  farModelFrom: 30,
  farModelBand: 2,       // ±: an instance switches to far beyond farModelFrom + band and back within farModelFrom − band (no flicker)
  cullMargin: 0.5,       // added to every instance's bounding radius before the view test
  shadowReachMax: 12,    // with shadow maps on, an instance out of view still draws when its shadow (at most this long) falls in view
} as const satisfies TuningBank;
